module.exports = __webpack_public_path__ + "media/images/seller-guide-protecting-id-thumb-6023e36121edde990626d523a0ac60d9.jpg";